<template>
  <div>
    <v-btn
      small
      @click="allowNotification"
      v-if="visibleNotification"
      light
      :disabled="waitAllowNotification"
      class="ml-2 px-2"
    >
      <v-icon small color="primary">
        mdi-bell
      </v-icon>
      通知
    </v-btn>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>
<script>
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { webPushTopic, webPushApi } from "../../config";
export default {
  name: "ChronologyNotification",
  components: {},
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      isNotificationSubscribed: false,
      vapidKey: null,
      waitAllowNotification: false
    };
  },

  computed: {
    isPrivate() {
      return process.env.VUE_APP_MODE === "private";
    },
    serviceWorkerRegistration() {
      return this.$store.getters.serviceWorkerRegistration;
    },
    userId() {
      return this.$store.getters.user.id;
    },
    visibleNotification() {
      return (
        this.isPrivate &&
        this.userId &&
        this.serviceWorkerRegistration !== null &&
        this.isNotificationSubscribed === false
      );
    }
  },

  watch: {
    serviceWorkerRegistration() {
      this.initializeNotification();
    }
  },

  async created() {
    console.log("chronology notification created");
  },

  beforeDestroy() {
    //
  },

  async mounted() {
    console.log("chronology notification mounted");
    if (this.serviceWorkerRegistration) {
      this.initializeNotification();
    }
  },

  methods: {
    showSnackbar(text) {
      this.snackbarText = text;
      this.snackbar = true;
    },

    async initializeNotification() {
      if (this.isPrivate !== true) return;
      if (!this.serviceWorkerRegistration) return;
      if (this.isNotificationSubscribed) return;

      const response = await webPushApi.get("/firebase_config");
      if (response.status === 200) {
        initializeApp(response.data);
      }
      this.serviceWorkerRegistration.pushManager
        .getSubscription()
        .then(subscription => {
          this.isNotificationSubscribed = subscription !== null;
          console.log("isSubscribed", this.isNotificationSubscribed);
          if (this.isNotificationSubscribed) {
            this.sendSubscribe(subscription);
          } else {
            this.unsubscribe();
          }
        })
        .catch(err => {
          console.error(`Error during getSubscription(): ${err}`);
        });
    },

    async getVapidKey() {
      if (this.vapidKey) return;
      const res = await webPushApi.get("/vapid_public_key");
      if (res === null || res.status !== 200 || !res.data.vapidKey) {
        this.showSnackbar("公開キーの取得に失敗しました");
      } else {
        this.vapidKey = res.data.vapidKey;
      }
    },

    async allowNotification() {
      if (this.waitAllowNotification === true) return;
      this.waitAllowNotification = true;
      console.log("allowNotification");

      if (this.serviceWorkerRegistration === null) {
        this.showSnackbar("通知関連のロードが完了していないため実行できません");
        this.waitAllowNotification = false;
        return;
      }

      if (Notification.permission !== "granted") {
        const permission = await Notification.requestPermission();
        if (permission === "denied") {
          this.showSnackbar("ブラウザの通知設定をONにしてください");
          this.waitAllowNotification = false;
          return;
        } else if (permission !== "granted") {
          this.showSnackbar("通知を許可してください");
          this.waitAllowNotification = false;
          return;
        }
      }

      await this.getVapidKey();
      if (!this.vapidKey) return;

      this.serviceWorkerRegistration.pushManager
        .subscribe({
          userVisibleOnly: true,
          applicationServerKey: this.vapidKey
        })
        .then(
          async subscription => {
            // 初回トークン取得時はなぜかエラーになるので、1秒待ってから再取得する
            const messaging = getMessaging();
            await getToken(messaging, { vapidKey: this.vapidKey }).catch();
            setTimeout(() => {
              this.sendSubscribe(subscription);
            }, 1000);
          },
          error => {
            console.error("pushManager error", error);
            this.showSnackbar("通知を許可できませんでした");
            this.waitAllowNotification = false;
          }
        );
    },

    async unsubscribe() {
      const token = localStorage.getItem("webpush_token");
      if (!token) return;
      await webPushApi.post("/unsubscribe", {
        topic: webPushTopic,
        token: token
      });
      localStorage.removeItem("webpush_token");
    },

    async sendSubscribe(subscription) {
      console.log("sendSubscribe");
      if (!subscription) {
        this.showSnackbar("トークンが取得できませんでした");
        this.waitAllowNotification = false;
        return;
      }
      if (!this.userId) {
        this.showSnackbar("ユーザーIDが取得できませんでした");
        this.waitAllowNotification = false;
        return;
      }

      await this.getVapidKey();
      if (!this.vapidKey) return;

      const messaging = getMessaging();
      getToken(messaging, { vapidKey: this.vapidKey })
        .then(async token => {
          console.log("token", token);
          if (!token) {
            this.showSnackbar("トークンの取得に失敗しました");
            this.waitAllowNotification = false;
            return;
          }

          const oldToken = localStorage.getItem("webpush_token");
          if (oldToken === token) {
            console.log("token is same");
            this.waitAllowNotification = false;
            return;
          } else {
            await this.unsubscribe();
          }

          const params = {
            topic: webPushTopic,
            token: token,
            user_agent: navigator.userAgent,
            user_id: this.userId
          };
          webPushApi.post("/subscribe", params).then(response => {
            this.waitAllowNotification = false;
            if (response.data.subscribed === true) {
              localStorage.setItem("webpush_token", token);
              if (this.isNotificationSubscribed === false) {
                this.showSnackbar("通知を許可しました");
                this.isNotificationSubscribed = true;
              }
            } else {
              this.showSnackbar("通知の許可に失敗しました");
            }
          });
        })
        .catch(err => {
          this.waitAllowNotification = false;
          console.log("An error occurred while retrieving token. ", err);
          this.showSnackbar("トークンの取得に失敗しました");
        });
    },

    async reload() {
      window.location.reload(true);
    }
  }
};
</script>
<style lang="scss" scoped>
//
</style>
